import { render, staticRenderFns } from "./ForumSearchField.vue?vue&type=template&id=4668b9b0&scoped=true"
import script from "./ForumSearchField.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSearchField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSearchField.vue?vue&type=style&index=0&id=4668b9b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668b9b0",
  null
  
)

export default component.exports